import { useMemo } from 'react';
import { asIdentityId } from 'stores/sessionReadiness';
import { useSessionStore } from 'stores/sessionStore';
import { useSupportUserStore } from 'stores/supportUserStore';
import { isInternalLoginEmail } from 'utils/internalEmailPolicies';

/** Verified session identity; browser storage is only a compatibility mirror. */
export function useEmail(): string {
  return useSessionStore((state) =>
    state.isAuthenticated ? (state.member?.email_address ?? '') : ''
  );
}

export function useOrgId(): string | null {
  return useSessionStore((state) =>
    state.isAuthenticated ? asIdentityId(state.organization?.salv_org_id) : null
  );
}

export function useIsSuperAdmin(): boolean {
  const email = useEmail();
  return (
    email.toLowerCase().endsWith('mason@salv.ai') ||
    email.toLowerCase().endsWith('john@salv.ai') ||
    email.toLowerCase().endsWith('michael@salv.ai')
  );
}

/**
 * @deprecated Use useSupportUser() from 'hooks/useSupportUser' instead.
 * This function is kept for backward compatibility.
 */
export function useIsSupport(): boolean {
  return useSupportUserStore((state) => state.isSupportUser);
}

export function useIsInternal(): boolean {
  const email = useEmail();
  return useMemo(() => isInternalLoginEmail(email.toLowerCase()), [email]);
}

export function useIsSupportOrInternal(): boolean {
  const isSupport = useIsSupport();
  const isInternal = useIsInternal();
  return isSupport || isInternal;
}
